import { call, debounce, put, takeLatest } from 'redux-saga/effects';

import { fetchTeamMemberList, findAllTeamMember } from '../../services/teamMemberService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import { FETCH_TEAM_MEMBER_LIST, FIND_ALL_TEAM_MEMBER } from './teamMember.actions';

function* fetchTeamMemberListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(fetchTeamMemberList, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

function* findAllTeamMemberListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(findAllTeamMember, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchTeamMember() {
  yield debounce(250, FETCH_TEAM_MEMBER_LIST, fetchTeamMemberListSaga);
  yield debounce(250, FIND_ALL_TEAM_MEMBER, findAllTeamMemberListSaga);
}
